import { FormControl, Spinner, FormLabel } from '@chakra-ui/react';

export const CostsLoading = () => (
    <FormControl mt="1rem">
        <FormLabel>Autotask Cost</FormLabel>
        <Spinner thickness="5px" emptyColor="gray.200" color="resolveOrange" />
    </FormControl>
);
